import { DisplayStyle3dSettingsProps } from "@itwin/core-common";
import { Viewport } from "@itwin/core-frontend";

export class DisplayStylesApp {

    /** Overrides the current display styles using the viewport API. */
    public static applyDisplayStyle(viewport: Viewport, style: DisplayStyle3dSettingsProps) {
        viewport.overrideDisplayStyle(style);
    }
}